<template>
    <ac-modal :title="'Providers Assigned'" ref="modal" @ac-modal-closed="close">
        <template>
            <div v-if="widgetReady">
                <div class="row">
                    <div class="col-md-12">
                        <employers-assigned-to-plan-pool :consultant-id="consultantId" :plan-pool-id="planPoolId">

                        </employers-assigned-to-plan-pool>
                    </div>
                    <div class="col-md-12">
                        <h3>Providers (physicians selected: {{ physicianCount }})</h3>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <input placeholder="Filter Providers" class="form-control" type="text" v-model="searchQuery">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <ac-button :action="selectAll" class="btn-sm btn-blue">
                            SELECT ALL
                        </ac-button>
                        <ac-button :action="deselectAll" class="btn-sm btn-blue">
                            DESELECT ALL
                        </ac-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="tree-border">
                            <p style="margin: 5px;">
                                Please select the healthcare providers that you wish to make
                                available to groups and their members through this provider offering.
                            </p>
                            <ac-kendo-tree :data="filteredProviders"
                                        :expand-on-init="false"
                                        :config="treeConfig"
                                        :prefPhysicians="prefPhysicians"
                                        :assigned-physicians="providersInPool"
                                        ref="tree"
                                        @toggle-preferred-status="togglePreferredStatus">
                            </ac-kendo-tree>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button class="btn btn-sm btn-green" :action="assignProviders">
                ASSIGN PROVIDERS
            </ac-button>
            <ac-button class="btn btn-sm btn-red" :action="cancel">
                CANCEL
            </ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import { api } from "../../../../global/framework/api.js";
    import EmployersAssignedToPlanPool from "./EmployersAssignedToPlanPool.vue";
    import _ from 'lodash';
    import { common } from "../../../../global/common.js";
    import AcButton from "../../../../global/customHtmlElements/AcButton.vue";    
    import {notifications} from "../../../../global/notifications.js";

    export default {
        name: "AssignProvidersToPlanModal",
        components: { AcButton, EmployersAssignedToPlanPool },
        props: { consultantId: { type: [Number], required: true } },
        data() {
            return {
                widgetReady: false,
                planPoolId: 0,
                planId: 0,
                availableProviders: [],
				tempSelectedProviders: [],
				selectedProviders: [],
				treeConfig: {
					check: this.onTreeNodeCheck,
					checkboxes: { checkChildren: true },
					dataBound: this.onTreeNodeCheck
				},
				selectedProvidersTreeConfig: {
					dataBound(e) {
						$(e.sender.element).find('li .k-in').addClass("fa fa-check");
					}
				},
				maxRecursion: 10,
				counter: 0,
				prefPhysicians: [],
                providersInPool: [],
                searchQuery: '',
                hasProvidersAssigned: false,
            };
        },
        computed: {
			physicianCount() {
				return this.tempSelectedProviders.filter((item) =>
					item.entityTypeId === common.ENTITY_TYPE.PHYSICIAN
				).length;
			},
            filteredProviders() {
                if (!this.searchQuery) {
                    return this.getTreeNodes(this.availableProviders);
                }

                const query = this.searchQuery.toLowerCase();
                let prov = this.availableProviders.filter(x =>
                    x.text.toLowerCase().includes(query)
                );
                return this.getTreeNodes(prov);
            },
		},
        created() {
			this.filterTrees = _.debounce((e) => {
				let searchText = e.target.value;
				this.$refs.tree.filter(searchText);
			}, 500);
		},
        methods: {
            async showModal({ planPoolId, planId }) {
                this.planPoolId = planPoolId;
                this.planId = planId;
                let [myProv, prefPhysicians, providersInPool] = await Promise.all([
                    api.getDataWithTwoIds('MediatorPlan', this.consultantId, 'GetTreeAndSelection', `${this.planPoolId}/${planId}`),
                    api.getDataWithTwoIds('MediatorPlan', this.consultantId, 'GetPreferredPhysiciansForPlanPool', this.planPoolId),
                    api.getDataWithTwoIds('MediatorPlan', this.consultantId, 'GetAssignedPhysiciansForPlanPool', this.planPoolId)
                ]);
                this.prefPhysicians = prefPhysicians;
                this.providersInPool = providersInPool;
                this.availableProviders = myProv;
                this.widgetReady = true;
                this.$refs.modal.open();
                return new Promise((resolve) => {
                    this.resolveRef = resolve;
                });
            },
			getInstance() {
				return $(this.$refs.tree).data('kendoTreeView');
			},
			getDomInstance() {
				return this.$refs.tree;
			},
			onTreeNodeCheck(event) {
				let ds = this.$refs.tree.getInstance().dataSource;
				this.tempSelectedProviders = [];
				this.selectedProviders = [];
				this.setSelectedNodes(ds.view());
				this.selectedProviders = this.getTreeNodes(this.tempSelectedProviders);

                let topSelectedParents = this.tempSelectedProviders.filter(ap => {
                    return !this.tempSelectedProviders.some(parent => parent.id === ap.parentEntityId);
                });
                this.selectedProviders = topSelectedParents;
			},
			setSelectedNodes(nodes) {
				for (let i = 0; i < nodes.length; i++) {
					let current = nodes[i];
					if (current.checked) {
						let node = current.node;
						this.tempSelectedProviders.push(
							{
								id: node.id, parentEntityId: node.parentEntityId,
								text: node.text, affiliations: node.affiliations,
								entityTypeId: node.entityTypeId,
							});
					}
					if (current.hasChildren) {
						this.setSelectedNodes(current.children.view());
					}
				}
			},
			selectAll() {
				this.setCheckedStatus(true);
				this.onTreeNodeCheck();
			},
			deselectAll() {
				this.tempSelectedProviders = [];
				this.selectedProviders = [];
				this.setCheckedStatus(false);
			},
			setCheckedStatus(checkStatus) {
				let treeInstance = this.$refs.tree.getInstance();
				$(this.$refs.tree.getDomInstance()).find('input[type="checkbox"]').each(function () {
					treeInstance.dataItem(this).set("checked", checkStatus);
				});
			},
			getTreeNodes(plainData, parentId = null) {
				let treeNodes = [];
				let currentCollection = plainData.filter((item) => {
					return parentId === null ?
						//top nodes with no parent id or nodes for which the parent is not in the collection
						(item.parentEntityId === null || (!plainData.some((c => c.id === item.parentEntityId))))
						: (item.parentEntityId === parentId) //Children for current parent
				});
				//console.log("Current collection:", currentCollection, ' for parent id:', parentId);
				for (let i = 0; i < currentCollection.length; i++) {
					let current = currentCollection[i];
					let copy = { ...current };
					let text = current.text;

					if (current.entityTypeId === common.ENTITY_TYPE.PHYSICIAN) {
						if (!current.showInSearch) text += " [Not visible in search]";
						if (!current.acceptingNewPatients) text += " [Not accepting new patients]";
					}
					copy.name = text;

					//console.log("Getting children for entity:", copy.name);
					treeNodes.push({
						node: copy,
						checked: current.checked,
						nodeChildren: current.entityTypeId === common.ENTITY_TYPE.PHYSICIAN
							? [] : this.getTreeNodes(plainData, current.id)
					});
				}
				return treeNodes;
			},
			getSelection() {
				return this.tempSelectedProviders.map((p) => p.id);
			},
            updateTree() {
				this.mounted();
			},
			async togglePreferredStatus({ id, newStatus }) {				
                await api.post('MediatorPlan', `${this.consultantId}/TogglePreferredPhysicianStatusForPlanPool/${this.planPoolId}/${id}/${newStatus}`);
                this.$refs.tree.updateTreeView();
			},
            async assignProviders() {
                let topParentIds = this.selectedProviders.map((p) => p.id);
                if (topParentIds.length === 0 || this.physicianCount === 0) {
                    notifications.showError({message: "At least one physician must be selected.", title: "Error"});
                    return;
                }
                let result = await api.postDataAsJson('MediatorPlan', 'AssignProvidersToPlanInPool', {
                    planPoolId: this.planPoolId, planId: this.planId, topParentIds: topParentIds
                });
                if (result) {
                    this.hasProvidersAssigned = true;
                    this.$bus.$emit(this.$bus.$AcEvents.PLAN_PROVIDER_CHANGE, topParentIds);
                    this.$refs.modal.close();
                }
            },
            cancel() {
                this.$refs.modal.close();
            },
            close() {
                if(!this.hasProvidersAssigned) {
                    this.resolveRef(false);
                }
                else {
                    this.resolveRef(true);
                }
            },
        }
    }
</script>

<style scoped>
    > > > .k-item {
        background-color: #fafafa !important;
        /* border-bottom: 1px solid lightgray !important; */
    }

    .tree-border {
        margin-bottom: 15px;
        padding: 5px;
        background-color: #fafafa;
        border-radius: 4px;
        border: 1px solid #aaa;
        border-collapse: separate;
        overflow: hidden;
    }
</style>